export default "__VITE_ASSET__C1lpzB5T__"